export default __webpack_public_path__ + "static/insurance-19d8485b13996f933b714711113e8623.jpeg";